import script from "./CommerceFooterContactEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceFooterContactEditor.vue?vue&type=script&setup=true&lang=js"

import "./CommerceFooterContactEditor.vue?vue&type=style&index=0&id=315ff820&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315ff820"]])

export default __exports__